import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../hooks/useLogout";
import { useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import LabStepHeader from "./LabStepHeader";
import { Button, Form } from "reactstrap";
import DateComponent from "../../../MyComp/UI/form/DateComponent";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MySelect from "../../../MyComp/UI/form/MySelect";
import MyButton from "../../../MyComp/UI/form/MyButton";
import moment from "moment";
import { createLabServiceAPI, getLabDetailsThree } from "../../../api/lab";
import { toast } from "react-toastify";
import MyNumber from "../../../MyComp/UI/form/MyNumber";

const LabService3 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      service: "",
      startTime: "",
      endTime: "",
      pincode: "",
      radius: "",
      mode: location?.state?.mode || "Add",
    },
  });

  const [mode] = useState(location?.state?.mode || "Add");
  const queryParams = new URLSearchParams(location.search);
  const labId = queryParams.get("labId");
  const isLoading = watch("isLoading");

  // --- Form Submit ---
  const onFormSubmit = (data) => {
    const body = {
      labId: labId,
      service: data.service?.value || data.service,
      startTime: data.startTime ? moment(data.startTime, ["hh:mm A", "HH:mm"]).format("hh:mm A") : null,
      endTime: data.endTime ? moment(data.endTime, ["hh:mm A", "HH:mm"]).format("hh:mm A") : null,
      // pincode: data.pincode,
      radius: data.radius,
    };

    if (mode === "Add" || mode === "Edit") {
      createLabServiceAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            navigate(`/laboratory-and-diagnostics/bank-and-documents?labId=${labId}`, {
              state: {
                mode: mode,
                labId: mode === "Add" ? res.data.data?.labId : location.state.labId,
              },
            });
          } else if (res.data.status === false) {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => console.error(err));
    }
  };

  // --- Fetch Edit Data ---
  const parseTimeString = (timeStr) => {
    if (!timeStr) return null;

    // Try parsing using moment, fallback gracefully
    const m = moment(timeStr, "hh:mm A");

    return m.isValid() ? m.toDate() : null;
  };

  useEffect(() => {
    if (mode === "Edit") {
      getLabServiceDetails();
    }
  }, [mode]);
  const getLabServiceDetails = () => {
    getLabDetailsThree({ labId: location.state.labId })
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.data;

          setValue("service", { value: data.service, label: data.service });

          // Parse into valid Date objects
          const start = parseTimeString(data.startTime);
          const end = parseTimeString(data.endTime);

          setValue("startTime", start);
          setValue("endTime", end);

          setValue("pincode", data.pincode || "");
          setValue("radius", data.radius || "");

          trigger();
        } else if (res.data.status === "expired") {
          logout();
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <Head title={"Service & Catalog"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Laboratory Registration
              </BlockTitle>
            </BlockHeadContent>
              <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <PreviewAltCard>
            <LabStepHeader current={3} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                {/* Service Select */}
                <Col xs="12" sm="6" md="4" lg="3">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    options={[
                      { value: "No", label: "No" },
                      { value: "Yes", label: "Yes" },
                    ]}
                    title="Collection Availability"
                    name="service"
                    placeholder="Select service type"
                    required
                  />
                </Col>

                {/* Start Time */}
                <Col xs="12" sm="6" md="4" lg="2">
                  <DateComponent
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Start Time"
                    name="startTime"
                    placeholder="Start time"
                    required
                    disabled={mode === "Approval"}
                  />
                </Col>

                {/* End Time */}
                <Col xs="12" sm="6" md="4" lg="2">
                  <DateComponent
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="End Time"
                    name="endTime"
                    placeholder="End time"
                    required
                    disabled={mode === "Approval"}
                  />
                </Col>

                {/* Pincode */}
                {/* by varun sir */}
                {/* <Col xs="12" sm="6" md="4" lg="2">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Service Area Pin Code"
                    name="pincode"
                    placeholder="Enter service area pin code"
                    required
                    min={6}
                    max={6}
                    disabled={mode === "Approval"}
                  />
                </Col> */}

                {/* Radius */}
                <Col xs="12" sm="6" md="4" lg="2">
                  <MyNumber
                    register={register}
                    setValue={setValue}
                    errors={errors}
                    title="Service Area Radius"
                    name="radius"
                    placeholder="Enter service area radius"
                    type="number"
                    min={5}
                    required
                  />
                </Col>
              </Row>

              {/* Submit Button */}
              {(mode === "Add" || mode === "Edit") && (
                <Row>
                  <Col md="12">
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default LabService3;
